import { ExaminationRoom } from '@/pages/clinic/examinationRooms/columns'
import { Tabs, TabsContent } from '@/components/ui/tabs'
import { AppointmentList } from './appointment/AppointmentList'

type AppointmentManagementProps = {
  examinationRoom?: ExaminationRoom
  isLoading?: boolean
  onSuccess?: () => void
}

export function AppointmentManagement({
  examinationRoom,
  isLoading,
  onSuccess,
}: AppointmentManagementProps) {
  // const [_, setViewMode] = useState<'list' | 'calendar'>('list')

  // 如果診間資料正在載入中或不存在，顯示載入中狀態
  if (isLoading || !examinationRoom) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-sm text-muted-foreground">載入中...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">預約掛號管理</h3>
        <p className="text-sm text-muted-foreground">
          管理 {examinationRoom.name} 診間的預約，您可以查看、新增、編輯和刪除預約。
        </p>
      </div>

      <Tabs defaultValue="list" className="w-full">
        {/* <div className="flex justify-between items-center mb-4">
          <TabsList>
            <TabsTrigger value="list" onClick={() => setViewMode('list')}>
              <ListIcon className="h-4 w-4 mr-2" />
              列表檢視
            </TabsTrigger>
            <TabsTrigger value="calendar" onClick={() => setViewMode('calendar')}>
              <CalendarIcon className="h-4 w-4 mr-2" />
              日曆檢視
            </TabsTrigger>
          </TabsList>
        </div> */}

        <TabsContent value="list" className="mt-0">
          <AppointmentList examinationRoom={examinationRoom} onSuccess={onSuccess} />
        </TabsContent>

        {/* <TabsContent value="calendar" className="mt-0">
          <AppointmentCalendar examinationRoom={examinationRoom} onSuccess={onSuccess} />
        </TabsContent> */}
      </Tabs>
    </div>
  )
}
